function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-question-circle",
  "data-name": "Icon awesome-question-circle",
  d: "M15.575,8.069A7.506,7.506,0,1,1,8.069.563,7.506,7.506,0,0,1,15.575,8.069ZM8.27,3.044a3.92,3.92,0,0,0-3.528,1.93.364.364,0,0,0,.082.492l1.05.8a.363.363,0,0,0,.5-.064c.541-.686.911-1.083,1.734-1.083.618,0,1.383.4,1.383,1,0,.453-.374.686-.985,1.028-.712.4-1.654.9-1.654,2.139V9.4a.363.363,0,0,0,.363.363H8.916A.363.363,0,0,0,9.279,9.4V9.36c0-.861,2.518-.9,2.518-3.228C11.8,4.376,9.976,3.044,8.27,3.044Zm-.2,7.506a1.392,1.392,0,1,0,1.392,1.392A1.394,1.394,0,0,0,8.069,10.551Z",
  transform: "translate(-0.563 -0.563)",
  fill: "#1dabfc"
});

function SvgQuestionCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.012,
    height: 15.012,
    viewBox: "0 0 15.012 15.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.79d9820d.svg";
export { ForwardRef as ReactComponent };